function DiagramFlow({ title, subtitle, steps = [], accent = "#e37921" }) {
  return (
    <section className="mx-auto max-w-[1280px] px-6 py-20 md:px-10">
      <div className="relative overflow-hidden rounded-[40px] border border-slate-200 bg-white p-10 shadow-[0_32px_64px_-16px_rgba(10,44,79,0.08)] md:p-16">
        {/* Decorative background element */}
        <div className="absolute -right-32 -top-32 h-64 w-64 rounded-full bg-slate-50 opacity-50" />

        <div className="relative z-10">
          <p className="text-[15px] font-black uppercase tracking-[0.25em]" style={{ color: accent }}>
            Workflow
          </p>
          <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[#0a2c4f] md:text-4xl">{title}</h2>
          {subtitle ? (
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-500">{subtitle}</p>
          ) : null}

          <div className="mt-16 grid gap-8 md:grid-cols-4">
            {steps.map((step, index) => (
              <div key={step.title} className="group relative">
                <div className="relative z-10 rounded-[32px] border border-slate-100 bg-white p-8 transition-all duration-500 hover:-translate-y-2 hover:border-[#df1f2d]/20 hover:shadow-[0_20px_40px_-12px_rgba(223,31,45,0.12)]">
                  <div
                    className="mb-8 inline-flex h-12 w-12 items-center justify-center rounded-2xl text-lg font-black text-white shadow-lg transition-transform duration-500 group-hover:rotate-[10deg] group-hover:scale-110"
                    style={{
                      backgroundColor: accent,
                      boxShadow: `0 10px 20px -5px ${accent}66`
                    }}
                  >
                    {index + 1}
                  </div>
                  <h3 className="text-xl font-bold tracking-tight text-[#0a2c4f]">{step.title}</h3>
                  <p className="mt-4 text-sm leading-relaxed text-slate-500">{step.text}</p>
                </div>

                {index !== steps.length - 1 ? (
                  <div className="absolute left-full top-1/2 z-0 hidden w-8 -translate-y-1/2 md:block">
                    <div className="h-[2px] w-full bg-gradient-to-r from-slate-200 to-slate-100" />
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default DiagramFlow;
